import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'

import Widget from '../components/Widget'
import Widget2 from '../components/Widget2' // Work on removing our mobx dependency
import AvailabilityCalendar from '../components/AvailabilityCalendar'
import AvailabilityChecker from '../components/AvailabilityChecker'
import ContactForm from '../components/ContactForm'
import AddOnGallery from '../components/AddOnGallery'
import PhotoboothBackgroundGallery from '../components/PhotoboothBackgroundGallery'
import DesignTemplateGallery from '../components/DesignTemplateGallery'
import EmployeeGallery from '../components/EmployeeGallery'
import AppointmentScheduler from '../components/AppointmentScheduler'
import MiniSessionBooking from '../components/MiniSessionBooking'
import { iframeResizerContentWindow } from 'iframe-resizer'
// import 'bootstrap/dist/css/bootstrap.css'
import '../helpers/bootstrap.scss'
import '../helpers/widgets.css'

const components = {
  "availability-calendar": AvailabilityCalendar,
  "availability-checker": AvailabilityChecker,
  "add-on-gallery": AddOnGallery,
  "contact-form": ContactForm,
  "design-template-gallery": DesignTemplateGallery,
  "employee-gallery": EmployeeGallery,
  "mini-session-booking": MiniSessionBooking,
  "photobooth-background-gallery": PhotoboothBackgroundGallery
}

Object.entries(components).forEach(entry =>  {
  const className = `checkcherry__widget__${entry[0]}`
  const component = entry[1]
  const nodes = Array.from(document.getElementsByClassName(className))
  nodes.forEach(node => {
    const props = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(
      React.createElement(Widget, props, 
        React.createElement(component, props)
      ), node)
  })
})

const mobxFreeComponents = {
  "appointment-scheduler": AppointmentScheduler,
}

Object.entries(mobxFreeComponents).forEach(entry =>  {
  const className = `checkcherry__widget__${entry[0]}`
  const component = entry[1]
  const nodes = Array.from(document.getElementsByClassName(className))
  nodes.forEach(node => {
    const props = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(
      React.createElement(Widget2, props, 
        React.createElement(component, props)
      ), node)
  })
})
